/**
 * Side-nav for the external single-order layout.
 *
 * @module singleOrderForExternal/components/OrderSideNav
 */
import SingleTab from "../../../components/singleTab/singleTab";

interface TabDescriptor {
  id: string;
  label: string;
}

interface OrderSideNavProps {
  tabs: TabDescriptor[];
}

/**
 * @param props - Tab list to render
 * @returns Stacked `SingleTab` entries
 */
const OrderSideNav = ({ tabs }: OrderSideNavProps) => (
  <div className="single-order-for-external--content--secondary__left--navigation">
    {tabs.map((tab) => (
      <SingleTab key={tab.id} id={tab.id} label={tab.label} />
    ))}
  </div>
);

export default OrderSideNav;
